export default "__VITE_ASSET__YYW_liKV__"